@if (label()) {
  <label for="inputText" class="col-span-12 mb-1 text-sm font-medium">
    {{ label() }}
    @if (required()) {
      <span class="text-indicator-error">*</span>
    }
  </label>
}

<input
  pInputText
  pSize="small"
  id="inputText"
  [type]="type()"
  [placeholder]="placeholder()"
  [value]="value"
  (input)="onInput($event)"
  (blur)="onBlur()"
  [disabled]="isDisabled()"
  [ngClass]="{ 'ng-invalid': showErrors, 'ng-dirty': showErrors }"
  (click)="$event.stopPropagation()"
  class="col-span-12"
/>

<app-helper-text
  class="col-span-12"
  [errorMessage]="errorMessage"
  [showErrors]="showErrors"
  [helperText]="helperText()"
/>
